"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Image = _interopRequireDefault(require("../Image"));
var _CardInfo = _interopRequireDefault(require("../CardInfo"));
var _NotificationBannerInline = _interopRequireDefault(require("../NotificationBannerInline"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _GtmContext = require("@airasia/phoenix-common/common/GtmContext");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _BaggageAllowance = _interopRequireDefault(require("./BaggageAllowance.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledIconContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageAllowance__StyledIconContainer",
  componentId: "sc-13i4de1-0"
})(["", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
    position = _ref.position,
    customized = _ref.customized;
  return position === 'left' ? "margin-right: ".concat(customized ? theme.space.none : theme.space.small, ";") : "margin-left: ".concat(theme.space.small, ";");
}, function (_ref2) {
  var customized = _ref2.customized;
  return customized && "filter:opacity(0.5) drop-shadow(0 0 0 gray);";
}, function (_ref3) {
  var titleFirst = _ref3.titleFirst;
  return titleFirst && "align-items:end;";
});
var ListParentContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageAllowance__ListParentContainer",
  componentId: "sc-13i4de1-1"
})(["", " padding-top:", ";"], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return !isMobile && "\n       display: flex;\n       flex-direction:".concat(isMobile ? "column" : 'row', ";\n       align-items:").concat(isMobile ? "start" : 'center', ";\n      ");
}, function (_ref5) {
  var theme = _ref5.theme,
    hasHeader = _ref5.hasHeader;
  return hasHeader ? "".concat(theme.space.normal) : "".concat(theme.space.none);
});
var ListContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageAllowance__ListContainer",
  componentId: "sc-13i4de1-2"
})(["flex-direction:row;align-items:center;padding-right:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.XSmall);
});
var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageAllowance__IconContainer",
  componentId: "sc-13i4de1-3"
})(["display:flex;flex-direction:row;align-items:center;padding-right:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.space.tiny);
});
var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageAllowance__TextContainer",
  componentId: "sc-13i4de1-4"
})(["display:flex;flex-direction:row;align-items:center;padding-right:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.space.micro);
});
var NotificationContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageAllowance__NotificationContainer",
  componentId: "sc-13i4de1-5"
})(["padding:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.space.small, " ").concat(theme.space.none, " ").concat(theme.space.none, " ").concat(theme.space.none);
});
var StyledHr = _styledComponents.default.hr.withConfig({
  displayName: "BaggageAllowance__StyledHr",
  componentId: "sc-13i4de1-6"
})(["border:none;border-top:", ";margin:", ";width:100%;"], function (_ref10) {
  var theme = _ref10.theme;
  return "1px solid ".concat(theme.colors.greyLight);
}, function (_ref11) {
  var theme = _ref11.theme;
  return " ".concat(theme.space.XSmall, " 0");
});
var ItemContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageAllowance__ItemContainer",
  componentId: "sc-13i4de1-7"
})(["display:flex;justify-content:space-between;"]);
var BaggageAllowance = function BaggageAllowance(_ref12) {
  var accessible = _ref12.accessible,
    theme = _ref12.theme,
    customProperties = _ref12.customProperties,
    hasBorder = _ref12.hasBorder,
    hasBoxShadow = _ref12.hasBoxShadow,
    hasTextToggle = _ref12.hasTextToggle,
    imgHeight = _ref12.imgHeight,
    imgWidth = _ref12.imgWidth,
    iconPosition = _ref12.iconPosition,
    titleFirst = _ref12.titleFirst,
    translation = _ref12.translation,
    dataList = _ref12.dataList,
    isMobile = _ref12.isMobile,
    hasHeader = _ref12.hasHeader,
    hasNoCheckedBaggage = _ref12.hasNoCheckedBaggage,
    hasNoCheckedBaggageOnly = _ref12.hasNoCheckedBaggageOnly,
    fireGtm = _ref12.fireGtm;
  var tabIndex = !accessible ? '-1' : '0';
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var gtmContext = (0, _GtmContext.useGtmContext)();
  (0, _react.useEffect)(function () {
    if ((hasNoCheckedBaggage || hasNoCheckedBaggageOnly) && fireGtm) {
      var errorObj = {
        translationKey: 'noCheckedBaggage',
        displayMessage: language.noCheckedBaggage
      };
      var gtmObj = _utilities.default.createGTMObject(errorObj, gtmContext);
      fireGtm(gtmObj);
    }
  }, [hasNoCheckedBaggage, hasNoCheckedBaggageOnly, fireGtm]);
  var renderIcon = function renderIcon(imageIcon) {
    return /*#__PURE__*/_react.default.createElement(StyledIconContainer, {
      position: iconPosition,
      titleFirst: titleFirst,
      customized: !!imageIcon
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      accessible: accessible,
      centerFocus: false,
      placeHolderBackground: "none",
      radius: "0px",
      theme: theme,
      src: imageIcon,
      height: imgHeight,
      width: imgWidth
    }));
  };
  var renderText = function renderText(textValue, isBold) {
    return /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      theme: theme,
      type: !hasHeader ? _constant.TEXT_PROPS.small : _constant.TEXT_PROPS.default,
      bold: isBold,
      color: hasHeader ? _constant.TEXT_PROPS.neutral : _constant.TEXT_PROPS.greyDark
    }, textValue));
  };
  var renderContent = function renderContent() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hasNoCheckedBaggageOnly && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasHeader && /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      display: _constant.TEXT_PROPS.block,
      theme: theme,
      type: _constant.TEXT_PROPS.small,
      hasToggle: hasTextToggle,
      translation: language,
      color: _constant.TEXT_PROPS.greyDark
    }, language.content), dataList.length > 0 ? /*#__PURE__*/_react.default.createElement(ListParentContainer, {
      isMobile: isMobile,
      hasHeader: hasHeader
    }, dataList.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ListContainer, {
        key: "".concat(item.iconName)
      }, hasHeader ? /*#__PURE__*/_react.default.createElement(ItemContainer, {
        tabIndex: tabIndex
      }, /*#__PURE__*/_react.default.createElement(ItemContainer, null, /*#__PURE__*/_react.default.createElement(IconContainer, null, renderIcon(item.iconName)), renderText(item.mainDisplayName, true)), /*#__PURE__*/_react.default.createElement(ItemContainer, null, renderText(item.value, false), item.mainDisplayNameQty && renderText("x ".concat(item.mainDisplayNameQty), false))) : /*#__PURE__*/_react.default.createElement(ItemContainer, {
        tabIndex: tabIndex
      }, /*#__PURE__*/_react.default.createElement(IconContainer, null, renderIcon(item.iconName)), item.mainDisplayNameQty > 1 && renderText("".concat(item.mainDisplayNameQty, " x "), false), renderText(item.value, true))), index !== dataList.length - 1 && isMobile && /*#__PURE__*/_react.default.createElement(StyledHr, null));
    }), !hasHeader && renderText(language.perGuest, false)) : null), hasNoCheckedBaggage || hasNoCheckedBaggageOnly ? /*#__PURE__*/_react.default.createElement(NotificationContainer, null, /*#__PURE__*/_react.default.createElement(_NotificationBannerInline.default, {
      theme: theme,
      message: language.noCheckedBaggage,
      type: "warning",
      customIcon: "WorkOffIcon"
    })) : null);
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_CardInfo.default, {
    accessible: accessible,
    customProperties: customProperties,
    theme: theme,
    title: !hasNoCheckedBaggageOnly && hasHeader && language.title || '',
    content: renderContent(),
    titleFirst: titleFirst,
    hasTextToggle: false,
    textLimit: false,
    hasBorder: hasBorder,
    hasBoxShadow: hasBoxShadow,
    hasHeader: hasHeader,
    contentAs: "div"
  }));
};
BaggageAllowance.propTypes = _BaggageAllowance.default.PropTypes;
BaggageAllowance.defaultProps = _BaggageAllowance.default.DefaultProps;
var _default = BaggageAllowance;
exports.default = _default;